import { render, staticRenderFns } from "./BaseHealthIndex.vue?vue&type=template&id=207ca990&scoped=true&"
import script from "./BaseHealthIndex.vue?vue&type=script&lang=js&"
export * from "./BaseHealthIndex.vue?vue&type=script&lang=js&"
import style0 from "./BaseHealthIndex.vue?vue&type=style&index=0&id=207ca990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ca990",
  null
  
)

export default component.exports